import React from 'react';
import { Button } from './Button';
export function StickyMobileButton() {
  return <div className="fixed bottom-4 left-4 right-4 z-50 md:hidden drop-shadow-xl" data-id="element-218">
      <Button fullWidth className="py-3 text-base" showIcon={false} data-id="element-219">
        Quiero mi fiesta Lista! 🎉
      </Button>
    </div>;
}